import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";
import { computed, ref } from "vue";
interface Props {
  activeIcon: IconType;
  inactiveIcon?: IconType;
  hoverIcon?: IconType;
  isActive?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchIconButton',
  props: {
    activeIcon: {},
    inactiveIcon: { default: undefined },
    hoverIcon: { default: undefined },
    isActive: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;
const isHover = ref(false);
const toggleHover = () => {
  isHover.value = !isHover.value;
};

const appliedIcon = computed(() => {
  if (props.isActive) {
    return props.activeIcon;
  }
  if (isHover.value && props.hoverIcon) {
    return props.hoverIcon;
  }

  return props.inactiveIcon ?? props.activeIcon;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Icon, {
    class: "icon",
    icon: appliedIcon.value,
    onMouseover: toggleHover,
    onMouseout: toggleHover
  }, null, 8, ["icon"]))
}
}

})